// src/firebase.js
import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyCeLezpwv8hmxEoWiAX0T2aSCZIWXggv5Q",
  authDomain: "songfarm-c7058.firebaseapp.com",
  projectId: "songfarm-c7058",
  storageBucket: "songfarm-c7058.firebasestorage.app",
  messagingSenderId: "883110232005",
  appId: "1:883110232005:web:f0c36a62f8d7e5c04515ac",
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
